// extracted by mini-css-extract-plugin
export default {"pagi-container":"Pagi_pagi-container__2k4G9","active":"Pagi_active__VDYTP"};